export const None = 'none'
export const Exception = 'exception'
export const Other = 'other'
export const Ambiguous = 'ambiguous'
export const Assert = 'assert'
export const CspViolation = 'CSPViolation'
export const DebugCommand = 'debugCommand'
export const Dom = 'DOM'
export const EventListener = 'EventListener'
export const Instrumentation = 'instrumentation'
export const Oom = 'OOM'
export const PromiseRejection = 'promiseRejection'
export const Xhr = 'XHR'
